(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["luxury-fabric-care"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-carbon-calculator]').forEach((calculator) => {
    const form = calculator.querySelector('form');
    const output = calculator.querySelector('output');
    const template = calculator.dataset.resultTemplate;
    const update = () => {
      const temperature = Number(form.querySelector('input[type="radio"]:checked')?.value || 0);
      const tumble = form.querySelector('[data-tumble]').checked ? 1.8 : 0;
      output.textContent = template.replace('__AMOUNT__', (temperature + tumble).toFixed(2));
    };
    form.addEventListener('change', update);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sle-inside-our-thinking"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialise = (root) => {
    if (!root || root.dataset.sleThinkingReady === 'true') return;

    const openButton = root.querySelector('[data-sle-thinking-open]');
    const dialog = root.querySelector('[data-sle-thinking-dialog]');
    if (!openButton || !dialog) return;

    root.dataset.sleThinkingReady = 'true';

    openButton.addEventListener('click', () => {
      if (typeof dialog.showModal === 'function') dialog.showModal();
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  };

  document.querySelectorAll('[data-sle-thinking]').forEach(initialise);
  document.addEventListener('shopify:section:load', (event) => {
    initialise(event.target.querySelector('[data-sle-thinking]'));
  });
})();

  } catch(e) { console.error(e); }
})();
})();
